(ns frontend.view.modals.curtains.fundraising-opportunity.on-hold-curtain
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.modals.curtains.fundraising-opportunity.events :as events]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :curtain.fundraising-opportunity/put-on-hold)

(defonce preset-months [1 2 3 6 12])

(defn month-selector
  [edit-state]
  (let [attribute :months
        value (get @edit-state attribute)
        options (concat (->> preset-months
                             (map (fn [num]
                                    {:value num
                                     :label (if (= num 1)
                                              (loc/tr :month-one)
                                              (loc/tr :months-num [num]))})))
                        [{:value 0
                          :label (loc/tr :select-custom-date)}])]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :label       (loc/tr :until)
       :mandatory?  true
       :options     options
       :value       (->> options
                         (cu/filter-by :value value)
                         (first))
       :on-change   (fn [selected-value]
                      (if (nil? selected-value)
                        (swap! edit-state dissoc attribute selected-value)
                        (swap! edit-state assoc attribute selected-value)))}]]))

(defn until-selector
  [edit-state]
  (let [attribute :until
        value (get @edit-state attribute)]
    [:div
     [data-input/view
      {:data-type   :data.type/datetime
       :placeholder (loc/tr :select-date)
       :full-width? true
       :value       value
       :on-change   (fn [utc-ms]
                      (swap! edit-state assoc attribute utc-ms))}]]))

(defn internal-comment-input
  [edit-state]
  (let [attribute :internal-comment
        value (get @edit-state attribute)]
    [labelled-input/view
     {:label     (loc/tr :put-on-hold-curtain/internal-comment)
      :data-type :data.type/text-multiline
      :value     value
      :on-change (fn [new-value]
                   (if (nil? new-value)
                     (swap! edit-state dissoc attribute new-value)
                     (swap! edit-state assoc attribute new-value)))}]))

(defn view
  [{:keys [_shown? _topmost? _close-modal! _props state]}]
  (let [edit-state (r/cursor state [:edit])]
    (fn [{:keys [shown? topmost? close-modal! props state]}]
      (let [{:keys [fundraising-opportunity-id reset-focus!]} props
            session-entities @session/entities
            fundraising-opportunity (get session-entities fundraising-opportunity-id)
            fundraising-opportunity-name (:fundraising-opportunity/opportunity-name fundraising-opportunity)
            header-text (loc/tr :put-on-hold-curtain/title [fundraising-opportunity-name])
            edit-vals @edit-state
            {:keys [months until]} edit-vals
            close-modal! (fn []
                           (close-modal!)
                           (when reset-focus!
                             (reset-focus!)))
            button-disabled? (or (not (some #{months} (conj preset-months 0)))
                                 (and (zero? months)
                                      (nil? until)))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :color         ::c/warning
          :close-button? true}
         [:<>
          [:i.fal.fa-pause-circle.mr-2]
          header-text]
         [:div
          {:class "flex flex-col gap-3"}
          [month-selector edit-state]
          (when (zero? months)
            [until-selector edit-state])
          [internal-comment-input edit-state]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           ::c/warning
           button-disabled?
           #(events/confirm-on-hold state fundraising-opportunity close-modal!)
           (loc/tr :fundraising-opportunity.put-on-hold-curtain/put-on-hold)
           nil]]]))))
